import React, { Component } from 'react';
import './css/privacy-page.css';

class ContactusPage extends Component {
	constructor(props){
		super(props);
		console.log("Privacy()");
	}
	componentDidMount() { }

	getContentEN() {
		return (
		<div className="content EN">
			<h1>Opta Privacy Policy</h1>
			<p>Last Update: <span className="strong">December 14, </span>2022</p>

			<p>Opta Information
			Intelligence Corp., a Verisk Company (“<span className="strong">Opta</span>”, “<span className="strong">we</span>”, or “<span className="strong">us</span>”)
			values and respects your privacy. We have prepared this privacy policy to describe
			the manner in which we collect, use and disclose personal information in the
			course of providing our solutions to our customers, through our website (the “<span className="strong">Website</span>”),
			as well as through other interactions with us. Opta is a subsidiary of Verisk
			Analytics, Inc. (“<span className="strong">Verisk</span>”) and a member of the Verisk global group of
			companies (“<span className="strong">Verisk Group of Companies</span>”).</p>

			<p></p><br/>
			<h3>TABLE OF CONTENTS</h3>

			<ul>
				<li>Collection and Use of Personal Information</li>
				<li>Sharingof Personal Information</li>
				<li>Information about our Website</li>
				<li>Safeguards and Retention</li>
				<li>Your Rights and Choices</li>
				<li>Access to Information</li>
				<li>Updates to the Privacy Policy</li>
				<li>Contact Us</li>
			</ul>

			<p></p><br/>
			<h3>COLLECTION AND USE OF PERSONAL INFORMATION</h3>

			<p>Opta collects
			and uses limited personal information in the course of providing solutions to our
			customers. In certain contexts, we may collect personal information on our own
			behalf, such as in connection with visits to our Website, job applications, and
			to send marketing communications.</p>

			<p>Our customers
			are responsible for providing all required notices, obtaining all necessary
			consents, and otherwise complying with applicable privacy laws with respect to
			the collection, use and disclosure of personal information in connection with the
			use of our solutions. </p>

			<p><span className="strong">Information we process on behalf of our customers</span>:</p>

			<p><span className="strong">Our Solutions</span>:  We provide a range of property intelligence and insurance risk
			management solutions to businesses. In the course of providing these solutions,
			we may collect, use and disclose personal information that our customers provide
			to us or that we collect on their behalf about their clients or prospective
			clients (such as name, address and insurance policy number). Depending on the
			solution, we also collect and analyze property-level data in order to generate
			peril and other property scores. Examples of the manner in which we may collect,
			use and disclose personal information on behalf of our customers when we
			provide our solutions include:</p>


			<ul>
				<li><span className="strong">
					Inspection Products</span>: We may collect
					personal information such as: photographs of properties, year of built,
					and other specifications such as dimensions, area and width of properties,
					foundation type, architectural style, number of kitchens, bathrooms and
					related information.,  when we conduct property inspections and loss
					control assessments on behalf of our customers. Please note that data
					elements will vary depending upon the nature of inspection ordered.</li>
				<li><span className="strong">
					Survey Products and Customer Communications: </span>
					We may collect personal information through surveys that we
					facilitate on behalf of our customers. For example, we may send surveys on
					behalf of our insurance company customers in order to obtain feedback on
					customer claims experiences. We may also collect information on vehicle
					insurance through surveys. In addition, we offer certain ancillary
					customer support services, such as sending communications to our
					customers’ clients regarding the status of their insurance. </li>
				<li><span className="strong">
					Insurance Leads</span>: We facilitate lead
					generation for insurance companies. In the course of offering these
					services, we collect personal information such as name and contact
					information about individuals from their mortgage provider and provide
					that information to our insurance carrier customers for the purpose of
					connecting prospective clients to insurance carriers.  </li>
				<li><span className="strong">
					Auto Insurance Services</span>: We provide
					insurance-related services to automobile companies, which include verifying
					client insurance coverage and authenticating registered clients on behalf
					of our customers. To provide these services, we may collect name, email
					address, phone number, VIN number and policy number. We may record calls
					for quality assurance and training purposes. </li>
				<li><span className="strong">
					Programmatic Marketing:</span> We provide
					advertising services to help our customers reach targeted audiences. In
					doing so, we may share addresses of properties without any personal
					identifiers with third parties for the purposes of delivering targeted ads
					on behalf of our customers.</li>
			</ul>


			<p><span className="strong">Information we collect and use through our Website and other interactions</span>:</p>

			<p>We may collect personal information when you:</p>

			<ul>
			<li>Sign up to receive marketing communications</li>
			<li>Attend one of our events</li>
			<li>Apply for a job at Opta </li>
			<li>Contact us with a question, comment or complaint</li>
			</ul>

			<p></p>




			<p><span className="strong">Marketing Communications</span>: If you sign up to receive email marketing
				communications, we will collect your name, job title and name of your employer<span className="strong">,
				</span>and work email address to send you<span className="strong"> </span>newsletters and other
				communications about our products and services. You can unsubscribe at any time
				by clicking the “unsubscribe” link included at the bottom of each email.
				Alternatively, you can opt out of receiving email marketing communications by
				contacting us at the contact information provided in the “Contact Us” section
				below. Please note that you may continue to receive transactional or
				account-related communications from us.</p>

			<p><span className="strong">Online Webinars and Seminars: </span>If you enrol in one of our
			complimentary seminars, we may collect your full name, email address, business
			title and work contact information in order to communicate with you and provide
			you with access to the seminar.<span className="strong"></span></p>

			<p><span className="strong">Events</span>: If you attend one of our events (or visit a booth at an event), we
			may collect business contact information such as your first and last name,
			company name, work email address and phone number. We collect this information
			so that we can communicate with you about the event and contact you about
			future events.</p>

			<p><span className="strong">Careers</span>: In connection with a job application or related inquiry, you may
			provide us with certain personal information about yourself (such as that
			contained in a resume, cover letter, or similar employment-related materials).
			We use this information for the purpose of processing and responding to your
			application for current and future career opportunities. See our Privacy Notice
			for additional information <a
			href="https://www.verisk.com/privacy-trademarks-use/online-privacy-notice/">https://www.verisk.com/privacy-trademarks-use/online-privacy-notice/</a></p>

			<p><span className="strong">Contact Us</span>: When you contact us with a
			comment, question, or complaint,you may be asked for information that
			identifies you, such as your name, address, and a telephone number, along with
			additional information we need to help us promptly answer your question or
			respond to your comment. We may retain this information to assist you in
			the future and to improve our customer service and products. </p>

			<p></p><br/>

			<h3>SHARING OF PERSONAL INFORMATION</h3>

			<p>We do not sell
			or disclose your personal information to third parties without your consent,
			except as set forth below or as required or permitted by law.</p>

			<p><span className="strong">Service
			Providers:</span>Your personal information will be
			transferred (or otherwise made available) to certain third parties (including
			our parent company, Verisk) that provide services on our behalf. We use service
			providers to provide services such ashosting the Website, providing call
			centre support, sending communications, maintaining or servicing our products, and
			providing advertising, analytics and marketing services. Our service providers
			are only provided with the information they need to perform their designated
			functions and are not authorized to use or disclose personal information for
			their own marketing or other purposes.Our service providers may be
			located outside the province in which you reside (which may, for individuals in
			Quebec, include transfer outside of Quebec), in Canada, or in the US, Ireland
			and other foreign jurisdictions. </p>

			<p><span className="strong">Legal and
			Compliance:</span>Weand our Canadian, U.S. and
			other foreign service providers may provide your personal information in
			response to a search warrant or other legally valid inquiry or order, or to
			another organization for the purposes of investigating a breach of an agreement
			or contravention of law, detecting, suppressing or preventing fraud, or as
			otherwise may be required or permitted by applicable Canadian, U.S. or other
			law or legal process, which may include lawful access by U.S. or foreign
			courts, law enforcement or other government authorities. Your personal
			information may also be disclosed where necessary for the establishment,
			exercise, or defence of legal claims and to investigate or prevent actual or
			suspected loss or harm to persons or property. Where a disclosure of our
			customers’ information is required by applicable law, we notify our customer
			prior to complying with such requirements (to the extent we are not prohibited
			from doing so) and co-operate with our customer’s instructions with respect to
			our response.</p>

			<p><span className="strong">Sale of Business</span>: We may transfer any
			information we have about you as an asset in connection with a proposed or
			completed merger, acquisition, or sale (including transfers made as part of
			insolvency or bankruptcy proceedings) involving all or part of Opta or as part
			of a corporate reorganization or other change in corporate control involving Opta
			or the Verisk Group of Companies.</p>

			<p></p><br/>

			<h3>INFORMATION ABOUT OUR WEBSITE</h3>

			<p><span className="strong">Visiting our
			Website:</span> In general, you can visit our
			Website without telling us who you are or submitting any personal information.
			However, we collect the IP (Internet protocol) addresses of all visitors to our
			Website and other related information such as page requests, browser type,
			operating system and average time spent on our Website. We use this information
			to help us understand our Website activity and to monitor and improve our
			Website.</p>

			<p><span className="strong">Cookies:</span>
			Our Website uses a technology called &quot;cookies&quot;. A cookie
			is a tiny element of data that our Website sends to a user’s browser, which may
			then be stored on the user’s hard drive so that we can recognize the user’s
			computer or device when they return. You may set your browser to notify you
			when you receive a cookie or to not accept certain cookies. However, if you
			decide not to accept cookies from our Website, you may not be able to take
			advantage of all of the Website features.</p>

			<p><span className="strong">Analytics:</span>
			We may use a third-party such as Google Analytics to help us
			gather and analyze information about the areas visited on the Website (such as
			the pages most read, time spent, search terms and other engagement data) in
			order to evaluate and improve the user experience and the Website. These third
			parties may use cookies and other tracking technologies. For more information
			about Google Analytics or to prevent the storage and processing of this data
			(including your IP address) by Google, you can download and install the browser
			plug-in available at the following link: <a
			href="https://tools.google.com/dlpage/gaoptout?hl=en">https://tools.google.com/dlpage/gaoptout?hl=en</a>.
			 You can also obtain additional information on Google Analytics’ data privacy
			and security at the following links:</p>

			<p><a
			href="https://policies.google.com/technologies/partner-sites">https://policies.google.com/technologies/partner-sites</a>
			and</p>

			<p><a
			href="https://support.google.com/analytics/topic/2919631">https://support.google.com/analytics/topic/2919631</a>
			</p>

			<p><span className="strong">Third-Party
			Links</span>: Our Website may contain links to other
			websites thatOpta does not own or operate. We provide links to third-party
			websites as a convenience to the user. These links are not intended as an
			endorsement of or referral to the linked websites. The linked websites have
			separate and independent privacy policies, notices, and terms of use. We do not
			have any control over such websites, and therefore we have no responsibility or
			liability for the manner in which the organizations that operate such linked
			websites may collect, use, or disclose, secure and otherwise treat personal
			information. We encourage you to read the privacy policy of every website you
			visit.</p>

			<p></p><br/>

			<h3>SAFEGUARDS AND RETENTION</h3>

			<p>We have
			implemented reasonable administrative, technical and physical measures in an
			effort to safeguard the personal information in our custody and control against
			theft, loss and unauthorized access, use, modification and disclosure. We
			restrict access to personal information on a need-to-know basis to employees
			and authorized service providers who require access to fulfil their job
			requirements.</p>

			<p>We have personal
			information retention processes designed to retain personal information for no
			longer than necessary for the purposes of providing services to our customers
			and in accordance with our contractual commitments or, with respect to the
			Website, for the purposes set out in this privacy policy, or to otherwise meet
			legal and business requirements. </p>

			<p></p><br/>
			<h3>YOUR RIGHTS AND CHOICES</h3>

			<p>
			As indicated above, if you have signed-up to receive our email
			communications, you can unsubscribe any time by clicking the “unsubscribe” link
			included at the bottom of the email. Alternatively, you can opt-out of
			receiving our marketing communications by contacting us at the contact
			information under “Contact Us” below. </p>

			<p></p>

			<p>If we receive a
			request from you to access or update personal information we maintain on behalf
			of a customer, we will direct you to the relevant customer. We will assist our
			customers wherever possible in responding to individual access requests.</p>

			<p>
			Subject to limited exceptions under applicable law, you have the
			right to access, update and correct inaccuracies in your personal information
			in our custody or control, and to withdraw your consent to our collection, use
			or disclosure of your personal information (subject to legal and contractual
			restrictions). You may request access, updating and corrections of inaccuracies
			in your personal information in our custody or control, or withdraw your consent,
			by emailing or writing to us at the contact information set out below. We may
			request certain personal information for the purpose of verifying the identity
			of the individual seeking access to his or her personal information records.</p>

			<p></p><br></br>

			<h3>UPDATES TO THE PRIVACY POLICY</h3>

			<p>
			We may update this privacy policy periodically to reflect changes to
			our privacy practices. We encourage you to periodically review this page to
			ensure you are familiar with those changes. We will indicate at the top of this
			privacy policy when it was most recently updated.</p>

			<p></p><br/>

			<h3>CONTACT US</h3>

			<p>If you have any
			questions or comments about this privacy policy or the manner in which we or
			our service providers (including our service providers outside Canada) treat
			your personal information, or to request access to or correction of your
			personal information, or to withdraw your consent, please contact us at:</p>

			<p><span className="strong">Privacy Officer</span></p>

			<p>Nancy Dean</p>
			<p>VP Global Compliance & Privacy Services</p>
			<p>Email: <a href="mailto:optaprivacy@verisk.com">optaprivacy@verisk.com</a></p>

			<p></p>

			<p>If you have any
			questions regarding the personal information we process on behalf of one of our
			customers, we encourage you to first contact the customer directly and/or
			review their applicable privacy policy.</p>
			<br/><br/><br/>
		</div>);
	}

	getContentFR() {
		return (
		<div className="content EN">
			<h1>Politique sur la protection des renseignements personnels d'Opta</h1>
			<p>Dernière mise à jour&nbsp;: <span className="strong">Le 14 décembre </span>2022</p>

			<p>Opta Intelligence informationnelle Corp., une société
			de Verisk ("&nbsp;<span className="strong">Opta</span>&nbsp;" ou "&nbsp;<span className="strong">nous</span>&nbsp;") valorise et
			respecte votre vie privée. Nous avons préparé cette politique sur la protection
			des renseignements personnels pour décrire la manière dont nous recueillons,
			utilisons et divulguons les informations personnelles dans le cadre de la
			prestation de solutions à nos clients, par le biais de notre site Web (le "&nbsp;<span className="strong">site
			Web</span>&nbsp;"), ainsi que via d'autres interactions avec nous. Opta est une
			filiale de Verisk Analytics, inc. ("&nbsp;<span className="strong">Verisk&nbsp;</span>") et un membre du
			groupe mondial de sociétés de Verisk ("&nbsp;Verisk Group of Companies&nbsp;").
			</p>

			<p></p><br/>
			<h3>TABLE DES MATIÈRES&nbsp;</h3>

			<ul>
				<li>Collecte et utilisation des renseignements personnels</li>
				<li>Partage des renseignements personnels</li>
				<li>Informations sur notre site Web</li>
				<li>Mesures de protection et conservation</li>
				<li>Vos droits et vos choix</li>
				<li>Accès à l'information</li>
				<li>Mises à jour de la Politique sur la protection des renseignements personnels</li>
				<li>Contactez-nous</li>
			</ul>

			<p></p><br/>
			<h3>COLLECTE ET UTILISATION DES RENSEIGNEMENTS PERSONNELS&nbsp;</h3>

			<p>Opta recueille et utilise des informations
			personnelles restreintes dans le cadre de la prestation de solutions à nos
			clients. Dans certains contextes, nous pouvons recueillir des renseignements
			personnels pour notre propre compte, par exemple dans le cadre de visites sur
			notre site Web, de demandes d'emploi et d'envoi de communications commerciales.</p>

			<p>Nos clients sont responsables de fournir tous les avis
			requis, d'obtenir tous les consentements nécessaires et de se conformer aux
			lois applicables en matière de confidentialité en ce qui concerne la collecte,
			l'utilisation et la divulgation de renseignements personnels dans le cadre de
			l'utilisation de nos solutions.</p>

			<p><span className="strong">Les informations que nous traitons pour le compte de nos clients</span>&nbsp;:</p>

			<p><span className="strong">Nos solutions&nbsp;</span>:&nbsp;Nous offrons aux entreprises une gamme de
				solutions de renseignements sur les biens immobiliers et de gestion des risques
				d'assurance. Dans le cadre de la prestation de ces solutions, nous pouvons
				collecter, utiliser et divulguer les informations personnelles que nos clients
				nous fournissent ou que nous collectons en leur nom sur leurs clients ou
				clients potentiels (telles que le nom, l'adresse et le numéro de police
				d'assurance). En fonction de la solution, nous collectons et analysons
				également les données relatives à la propriété afin de générer l'indice de
				risque et d'autres risques pour la propriété. Voici des exemples de la façon
				dont nous pouvons recueillir, utiliser et divulguer des renseignements
				personnels au nom de nos clients lorsque nous offrons nos solutions&nbsp;:</p>

			<ul>
				<li><span className="strong">
					Produits d'inspection</span>&nbsp;:&nbsp;Nous pouvons collecter
					des informations personnelles telles que&nbsp;des photographies de
					propriétés, l'année de construction et d'autres spécifications telles que
					les dimensions, la superficie et la largeur des propriétés, le type de
					fondation, le style architectural, le nombre de cuisines, de salles de
					bains et autres informations connexes, lorsque nous effectuons des
					inspections de propriétés et des évaluations de prévention de sinistres
					pour le compte de nos clients. Veuillez noter que les éléments de données
					varient en fonction de la nature de l'inspection commandée.</li>
				<li><span className="strong">
					Produits de sondage et communications avec les clients&nbsp;:</span>
					Nous pouvons collecter des informations personnelles par le biais de
					sondages que nous réalisons pour le compte de nos clients. Par exemple,
					nous pouvons envoyer des sondages au nom des clients des compagnies
					d'assurance afin d'obtenir des commentaires sur les expériences de
					réclamation des clients. Nous pouvons également collecter des informations
					sur l'assurance automobile par le biais de sondages. En outre, nous
					offrons certains services auxiliaires de soutien à la clientèle, tels que
					l'envoi de communications aux clients de nos clients concernant le statut
					de leur assurance.</li>
				<li><span className="strong">Pistes en assurance&nbsp;:</span>&nbsp;Nous facilitons la génération de
					piste pour les compagnies d'assurance. Dans le cadre de ces services, nous
					recueillons des renseignements personnels tels que le nom et les coordonnées
					des personnes auprès de leur fournisseur de prêts hypothécaires et
					fournissons ces renseignements à nos clients assureurs dans le but de
					mettre en relation des clients potentiels avec des compagnies d'assurance.</li>
				<li><span className="strong">Services d'assurance automobile</span>&nbsp;:&nbsp;Nous fournissons des
					services liés à l'assurance aux entreprises automobiles, notamment la
					vérification de la couverture d'assurance des clients et
					l'authentification des clients enregistrés au nom de nos clients. Pour
					fournir ces services, nous pouvons collecter le nom, l'adresse courriel,
					le numéro de téléphone, le numéro d’identification du véhicule et le
					numéro de police. Nous pouvons enregistrer les appels à des fins
					d'assurance qualité et de formation.</li>
				<li><span className="strong">Marketing programmatique&nbsp;:</span>&nbsp;Nous offrons des services
					publicitaires pour aider nos clients à atteindre des publics ciblés. Dans
					cette optique, nous pouvons partager des adresses de propriétés sans
					identifiants personnels avec des tiers dans le but de diffuser des
					publicités ciblées pour le compte de nos clients.</li>
			</ul>

			<p><span className="strong">Les informations que nous collectons et utilisons via notre site Web et d'autres interactions</span>&nbsp;:</p>

			<p>Nous pouvons recueillir des renseignements personnels lorsque vous&nbsp;:</p>

			<ul>
				<li>vous inscrivez pour recevoir des communications marketing</li>
				<li>participez à l'un de nos événements</li>
				<li>postulez à un emploi chez Opta</li>
				<li>nous contactez pour poser une question, faire un commentaire ou déposer une plainte</li>
			</ul>

			<p><span className="strong">Communications commerciales</span>&nbsp;:&nbsp;Si vous vous inscrivez pour
				recevoir des communications commerciales par courriel, nous recueillerons votre
				nom, votre fonction et le nom de votre employeur<span className="strong">, </span>et votre courriel
				professionnel pour vous envoyer<span className="strong"> </span>des bulletins d'information et d'autres
				communications sur nos produits et services. Vous pouvez vous désabonner à tout
				moment en cliquant sur le lien "&nbsp;se désabonner&nbsp;" figurant au bas de
				chaque courriel. Vous pouvez également refuser de recevoir des communications
				commerciales par courriel en nous contactant aux coordonnées indiquées dans la
				section "&nbsp;Contactez-nous&nbsp;" ci-dessous. Veuillez noter que vous pouvez
				continuer à recevoir des communications transactionnelles ou liées à votre
				compte de notre part.</p>

			<p><span className="strong">Webinaires et séminaires en ligne&nbsp;:&nbsp;</span>Si vous vous inscrivez à l'un de nos
			séminaires gratuits, nous pouvons recueillir votre nom complet, votre adresse
			courriel, votre titre et vos coordonnées professionnelles afin de communiquer
			avec vous et vous donner l'accès au séminaire.<span className="strong"> </span></p>

			<p><span className="strong">Événements</span>&nbsp;:&nbsp;Si vous participez à l'un de nos
			événements (ou visitez un kiosque lors d'un événement), nous pouvons collecter
			des coordonnées professionnelles telles que vos nom et prénom, le nom de votre
			entreprise, votre adresse courriel professionnelle et votre numéro de
			téléphone. Nous recueillons ces informations afin de pouvoir communiquer avec
			vous au sujet de l'événement et vous contacter pour des événements futurs.</p>

			<p><span className="strong">Carrières</span>&nbsp;:&nbsp;Dans le cadre d'une demande d'emploi ou d'une demande
			connexe, vous pouvez nous fournir certaines informations personnelles vous
			concernant (telles que celles contenues dans un curriculum vitae, une lettre de
			motivation ou des documents similaires liés à l'emploi). Nous utilisons ces
			informations dans le but de traiter et de répondre à votre candidature pour les
			occasions de carrière actuelles et futures. Voir notre Politique sur la
			protection des renseignements personnels pour plus d'informations à <a
			href="https://www.verisk.com/privacy-trademarks-use/online-privacy-notice/%20">
			https://www.verisk.com/privacy-trademarks-use/online-privacy-notice/
			</a></p>

			<p><span className="strong">Contactez-nous&nbsp;</span>:&nbsp;Lorsque vous nous contactez pour
			nous transmettre un commentaire, une question ou une plainte, on pourrait vous
			demander des informations permettant de vous identifier, telles que votre nom,
			votre adresse et un numéro de téléphone, ainsi que toute information
			supplémentaire nécessaire pour nous aider à répondre rapidement à votre
			question ou à votre commentaire.&nbsp; Nous pouvons conserver ces informations
			pour vous aider à l'avenir et pour améliorer notre service à la clientèle et
			nos produits.</p>

			<p></p><br/>

			<h3>PARTAGE DE RENSEIGNEMENTS PERSONNELS</h3>


			<p>Nous ne vendons ni ne divulguons vos informations
				personnelles à des tiers sans votre consentement, sauf dans les cas énoncés
				ci-dessous ou lorsque la loi l'exige ou le permet.</p>

				<p><span className="strong">Fournisseurs de services&nbsp;:</span>&nbsp;Vos informations personnelles seront
				transférées (ou autrement mises à disposition) à certains tiers (y compris
				notre société mère, Verisk) qui offrent des services en notre nom. Nous faisons
				appel à des prestataires de services pour obtenir des services tels que
				l'hébergement du site Web, le soutien du centre d'appels, l'envoi de
				communications, le maintien ou l'entretien de nos produits et la fourniture de
				services de publicité, d'analyse et de marketing. Nos prestataires de services
				ne reçoivent que les informations dont ils ont besoin pour remplir leurs
				fonctions désignées et ne sont pas autorisés à utiliser ou à divulguer des
				informations personnelles à leurs propres fins commerciales ou autres.&nbsp;Nos
				fournisseurs de services peuvent être situés à l'extérieur de la province dans
				laquelle vous résidez (ce qui peut, pour les personnes du Québec, inclure le
				transfert à l'extérieur du Québec), au Canada ou aux États-Unis, en Irlande et
				dans d'autres juridictions étrangères.
			</p>

			<p><span className="strong">Lois et conformité&nbsp;:&nbsp;</span>Nous&nbsp;et nos fournisseurs de services
			canadiens, américains et étrangers pouvons fournir vos renseignements
			personnels en réponse à un mandat de perquisition ou à une autre demande ou
			ordonnance légalement valable, ou à une autre organisation dans le but
			d'enquêter sur une violation d'un accord ou d'une infraction à la loi, de
			détecter, de supprimer ou de prévenir la fraude, ou tel qu'autrement requis ou
			permis par la loi ou le processus juridique canadien, américain ou tout autre
			applicable, qui peut comprendre l'accès légal par les tribunaux américains ou
			étrangers, les autorités policières ou d'autres autorités gouvernementales. Vos
			informations personnelles peuvent également être divulguées lorsque cela est
			nécessaire pour l'établissement, l'exercice ou la défense de réclamations
			légales et pour enquêter ou prévenir des pertes ou des préjudices réels ou
			présumés à des personnes ou à des biens. Lorsque la divulgation des
			informations de nos clients est requise par la loi applicable, nous en
			informons notre client avant de nous conformer à ces exigences (dans la mesure
			où il ne nous est pas interdit de le faire) et coopérons avec les instructions
			de notre client en ce qui concerne notre réponse.</p>

			<p ><span className="strong">Vente d'entreprise</span>&nbsp;: Nous pouvons transférer toute
			information que nous détenons à votre sujet en tant qu'actif dans le cadre
			d'une fusion, d'une acquisition ou d'une vente proposée ou achevée (y compris
			les transferts effectués dans le cadre d'une procédure d'insolvabilité ou de
			faillite) impliquant Opta dans son entièreté ou une partie de l'entreprise ou
			dans le cadre d'une réorganisation d'entreprise ou d'un autre changement de
			contrôle d'entreprise concernant Opta ou le groupe de sociétés Verisk.</p>

			<p></p><br/>

			<h3>INFORMATION CONCERNANT NOTRE SITE WEB</h3>

			<p><span className="strong">Visite de notre site Web&nbsp;:</span>&nbsp;En général, vous pouvez visiter notre
			site Web sans nous dire qui vous êtes ou sans soumettre de renseignements
			personnels. Cependant, nous recueillons les adresses IP (protocole Internet) de
			tous les visiteurs de notre site Web et d'autres informations connexes telles
			que les demandes de page, le type de navigateur, le système d'exploitation et
			le temps moyen passé sur notre site Web. Nous utilisons ces informations pour
			nous aider à comprendre l'activité de notre site Web et pour controller et
			améliorer notre site Web.</p>

			<p><span className="strong">Témoins de connexion&nbsp;:&nbsp;</span>Notre site Web utilise une technologie
			appelée "&nbsp;témoins de connexion&nbsp;". Un témoin de connexion est un
			minuscule élément de données que notre site Web envoie au navigateur d'un
			utilisateur, qui peut ensuite être stocké sur le disque dur de l'utilisateur
			afin que nous puissions reconnaître l'ordinateur ou l'appareil de l'utilisateur
			lorsqu'il revient. Vous pouvez configurer votre navigateur de façon à vous
			avertir lorsque vous recevez un témoin de connexion ou pour ne pas accepter
			certains témoins de connexion. Cependant, si vous décidez de ne pas accepter
			les témoins de connexion de notre site Web, vous ne pourrez peut-être pas
			profiter de toutes les fonctionnalités du site Web.</p>

			<p><span className="strong">Analyse&nbsp;:</span>&nbsp;Nous pouvons faire appel à un tiers tel que
			Google Analytics pour nous aider à collecter et à analyser des informations sur
			les zones visitées du site Web (telles que les pages les plus lues, le temps
			passé, les termes de recherche et autres données d'engagement) afin d'évaluer
			et d'améliorer l'expérience utilisateur et le site Web. Ces tiers peuvent
			utiliser des témoins de connexion et d'autres technologies de suivi. Pour plus
			d'informations sur Google Analytics ou pour empêcher le stockage et le
			traitement de ces données (y compris votre adresse IP) par Google, vous pouvez
			télécharger et installer le module externe de navigation se trouvant au lien
			suivant&nbsp;:&nbsp;<a
			href="https://tools.google.com/dlpage/gaoptout?hl=fr">
			https://tools.google.com/dlpage/gaoptout?hl=fr</a>. Vous pouvez également obtenir des
			informations supplémentaires sur la confidentialité et la sécurité des données
			de Google Analytics via les liens suivants&nbsp;:</p>

			<p>
			<a href="https://policies.google.com/technologies/partner-sites">
			https://policies.google.com/technologies/partner-sites</a>&nbsp;&nbsp;and</p>

			<p>
			<a href="https://support.google.com/analytics/topic/2919631">
			https://support.google.com/analytics/topic/2919631</a></p>

			<p><span className="strong">Liens aux tierces parties&nbsp;</span>:&nbsp;Notre site Web peut contenir des
			liens vers d'autres sites Web qu'Opta ne possède pas ou n'exploite pas. Nous
			fournissons des liens vers des sites Web de tiers à titre de commodité pour
			l'utilisateur. Ces liens ne constituent pas une approbation ou une référence
			aux sites Web liés. Les sites Web liés ont des politiques de confidentialité,
			des avis et des conditions d'utilisation distincts et indépendants. Nous
			n’avons aucune influence sur ces sites Web et donc aucune obligation ni
			responsabilité quant à la manière selon laquelle ces organisations, qui
			exploitent ces sites liés, collectent, utilisent, divulguent ou traitent les
			renseignements personnels. Nous vous incitons à lire la politique de
			confidentialité de tous les sites que vous visitez.</p>

			<p></p><br/>

			<h3>MESURES DE PROTECTION ET DE CONSERVATION</h3>

			<p>Nous avons mis en œuvre des mesures administratives,
			techniques et physiques raisonnables afin de protéger les renseignements
			personnels dont nous avons en notre possession contre le vol, la perte et
			l'accès, l'utilisation, la modification et la divulgation non autorisés. Nous
			limitons l'accès aux renseignements personnels selon le principe d'accès
			sélectif aux employés et aux fournisseurs de services autorisés qui doivent y
			avoir accès pour répondre à leurs exigences professionnelles.</p>

			<p>Nous avons des processus de conservation des
			renseignements personnels conçus pour ne pas conserver ces derniers plus
			longtemps que nécessaire afin d'offrir des services à nos clients et
			conformément à nos engagements contractuels ou, en ce qui concerne le site Web,
			aux fins énoncées dans la présente Politique sur la protection des
			renseignements personnels, ou pour répondre autrement aux exigences légales et
			commerciales.</p>

			<p></p><br/>
			<h3>VOS DROITS ET VOS CHOIX</h3>

			<p>Comme indiqué ci-dessus, si vous vous êtes
			inscrit pour recevoir nos communications par courriel, vous pouvez vous
			désabonner à tout moment en cliquant sur le lien "&nbsp;se désabonner&nbsp;"
			figurant au bas du courriel. Vous pouvez autrement refuser de recevoir des
			communications commerciales par courriel en nous contactant aux coordonnées
			fournies dans la section "&nbsp;Contactez-nous&nbsp;" ci-dessous.</p>

			<p>&nbsp;</p>

			<p>Si nous recevons une demande de votre part pour
			accéder ou mettre à jour les informations personnelles que nous conservons au
			nom d'un client, nous vous dirigerons vers le client concerné. Nous aiderons
			nos clients, dans la mesure du possible, à répondre aux demandes d'accès
			individuelles.</p>

			<p >Sous réserve d'exceptions limitées en vertu
			de la loi applicable, vous avez le droit d'accéder à vos informations
			personnelles, de les mettre à jour et de corriger les inexactitudes dans vos
			renseignements personnels en notre possession ou sous notre contrôle, et de
			retirer votre consentement à la collecte, à l'utilisation ou à la divulgation
			de vos informations personnelles (sous réserve des restrictions légales et
			contractuelles). Vous pouvez demander l'accès, la mise à jour et la correction
			des inexactitudes dans vos renseignements personnels en notre possession ou
			sous notre contrôle, ou retirer votre consentement, en nous envoyant un
			courriel ou en nous écrivant aux coordonnées indiquées ci-dessous. Nous pouvons
			demander certaines informations personnelles aux fins de vérification de
			l’identité de l’individu demandant accès à ses dossiers d'informations
			personnelles.</p>

			<p></p><br/>

			<h3>MISES À JOUR DE LA POLITIQUE SUR LA PROTECTION DES RENSEIGNEMENTS PERSONNELS</h3>

			<p >Nous pouvons mettre à jour la présente
			Politique sur la protection des renseignements personnels afin d'illustrer les
			modifications apportées à nos pratiques en matière de confidentialité. Nous
			vous encourageons à consulter régulièrement cette page pour vous assurer que
			vous êtes au courant de ces changements. Nous indiquerons en haut de cette
			Politique sur la protection des renseignements personnels la date de la plus
			récente mise à jour.</p>

			<p></p><br/>

			<h3>CONTACTEZ-NOUS</h3>

			<p>Si vous avez des questions ou des commentaires au
			sujet de la présente Politique sur la protection des renseignements personnels
			ou sur la façon dont nous ou nos fournisseurs de services (y compris nos
			fournisseurs de services à l'extérieur du Canada) traitons vos renseignements
			personnels, ou pour demander l'accès ou la correction de ces derniers, ou pour
			retirer votre consentement, veuillez communiquer avec nous à l'adresse
			suivante&nbsp;:</p>

			<p><span className="strong">Responsable de la protection des renseignements personnels</span></p>

			<p>Nancy Dean</p>
			<p>Vice-Présidente des services mondiaux de conformité et de confidentialité</p>
			<p>Courriel&nbsp;:<a href="mailto:%20optaprivacy@verisk.com%20">&nbsp;optaprivacy@verisk.com</a></p>

			<p>&nbsp;</p>

			<p>Si vous avez des questions concernant les informations
			personnelles que nous traitons au nom de l'un de nos clients, nous vous
			encourageons en premier lieu à contacter directement le client et/ou à
			consulter sa politique sur la protection des renseignements personnels
			applicable.</p>

			<br/><br/><br/>
			
		</div>);
	}

	componentWillUnmount() {
	}

	render() {
		var theContent = "";
		if (window.locale === "FR") theContent = this.getContentFR();
		else theContent = this.getContentEN();
		return(
		<div id="privacy-page">
			<div className="banner"/>
			<div className="txt1">{ window.l10n[window.locale]["landing.privacypolicy"] }</div>
			<div className="content-frame">
				{theContent}
			</div>
		</div>

		)
	}
}

export default ContactusPage;



// WEBPACK FOOTER //
// ./src/components/privacy-page.js